import { useTranslation } from 'react-i18next';

interface RatingCellProps {
  average: number | null;
  count: number;
}

/**
 * "4.6 / 5" over a sub-line, as the design's list cell draws it. The design's sub-line counts
 * interventions, which have no source until lot L4; the number of ratings is real data and the
 * design's own `title` for the cell, so it fills that line rather than a figure nobody measured.
 */
const RatingCell = ({ average, count }: RatingCellProps) => {
  const { t, i18n } = useTranslation();
  // Em dash, like every other empty cell on the row — and never a 0, which nothing measured.
  if (average == null || count === 0) return <span className="text-sm text-muted-foreground">—</span>;
  const ratings = t('{{count}} rating', { count });
  return (
    <div className="flex flex-col gap-0.5" title={ratings}>
      <span className="inline-flex items-center gap-1 whitespace-nowrap">
        <span className="text-[13px] font-medium">
          {average.toLocaleString(i18n.language, { minimumFractionDigits: 1, maximumFractionDigits: 1 })}
        </span>
        <span className="text-[11.5px] text-muted-foreground/70">/ 5</span>
      </span>
      <span className="block truncate text-[11px] text-muted-foreground/70">{ratings}</span>
    </div>
  );
};

export default RatingCell;
